import { useVpsHostingSectionContent } from './useVpsHostingSectionContent';
import { parseVpsHostingFaqContent } from '../utils/vpsHostingContent';

export const useVpsHostingFaqContent = () =>
  useVpsHostingSectionContent(parseVpsHostingFaqContent);
